// <photo-lightbox> wraps links with class "photo". Each link's href is the large image, so without JS
// the photo opens on its own. With JS a click opens the photo over the page (ported from lightboxInit in
// docs/design/maqueta.html): role="dialog", a click or Escape closes it, and the focus goes back to the link.
// data-close holds the "tap to close" text, rendered from the locale.
class PhotoLightbox extends HTMLElement {
  connectedCallback() {
    // connectedCallback runs again if the element is moved in the DOM; bind only once
    if (this.bound) return;
    this.bound = true;
    this.addEventListener("click", e => {
      const link = e.target instanceof Element ? e.target.closest("a.photo") : null;
      if (!link || !this.contains(link)) return;
      // let the browser do its thing for a new tab, a download or a modified click
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      e.preventDefault();
      this.open(link);
    });
  }

  open(link) {
    const label = link.dataset.label || "";
    const box = document.createElement("div");
    box.className = "lightbox";
    box.setAttribute("role", "dialog");
    box.setAttribute("aria-modal", "true");
    box.setAttribute("aria-label", label);
    box.tabIndex = -1;

    const inner = document.createElement("div");
    const img = document.createElement("img");
    img.src = link.href;
    img.alt = label;
    const caption = document.createElement("p");
    caption.textContent = this.dataset.close ? `${label}. ${this.dataset.close}` : label;
    inner.append(img, caption);
    box.append(inner);

    const close = () => {
      box.remove();
      document.removeEventListener("keydown", onKey);
      link.focus();
    };
    const onKey = ev => { if (ev.key === "Escape") close(); };
    box.addEventListener("click", close);
    document.addEventListener("keydown", onKey);
    document.body.append(box);
    box.focus();
  }
}

if (!customElements.get("photo-lightbox")) customElements.define("photo-lightbox", PhotoLightbox);
